import styled from "styled-components";

export const Wrapper = styled.div`
  background: #ffffff;
  box-shadow: var(--box-shadow-1);
  border-radius: 1.2rem;
  padding: 1rem 2rem;
  margin-bottom: 2.5rem;
`;

export const Header = styled.header`
  padding-bottom: 0.8rem;
  border-bottom: 1px solid var(--gray-5);
  margin-bottom: 2.5rem;
  font-size: 1.2rem;
  font-weight: 600;
`;

export const Content = styled.div``;
